// extracted by mini-css-extract-plugin
export var celebration = "HeaderLogo-module--celebration--d7505";
export var easter = "HeaderLogo-module--easter--f16d9";
export var easterShown = "HeaderLogo-module--easterShown--9f29e";
export var letters = "HeaderLogo-module--letters--46d35";
export var logo = "HeaderLogo-module--logo--7060a";
export var mobile = "HeaderLogo-module--mobile--fe30b";
export var monochrome = "HeaderLogo-module--monochrome--5dd53";
export var regular = "HeaderLogo-module--regular--cc121";
export var rocket = "HeaderLogo-module--rocket--532e2";
export var root = "HeaderLogo-module--root--0da62";